import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useForm } from '../hooks/form';
import toast from 'react-hot-toast';
import FormInput from './FormInput';

const Register = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  
  const { form, loading, handleOnChange, errors, post } = useForm({
    name: '',
    email: '',
    password: '',
    password_confirmation: ''
  });
  
  const handleSubmit = (e) => {
    e.preventDefault();
    post("/api/register")
      .then((response) => {
        toast.success(t('messages.registerSuccess'));
        navigate('/login');
      })
      .catch((error) => {
        console.error('Registration error', error);
      });
  };
  
  return (
    <div className="px-24 py-40 border border-gray-100 hover-border-main-600 transition-1 rounded-16">
      <h6 className="mb-32 text-xl">{t('common.register')}</h6>
      <form onSubmit={handleSubmit}>
        <FormInput
          label={t('common.name')}
          name="name"
          value={form.name}
          onChange={handleOnChange}
          errors={errors.name}
          required
        />
        
        <FormInput
          label={t('common.email')}
          type="email"
          name="email"
          value={form.email}
          onChange={handleOnChange}
          errors={errors.email}
          required
        />
        
        <FormInput
          label={t('common.password')}
          type="password"
          name="password"
          value={form.password}
          onChange={handleOnChange}
          errors={errors.password}
          required
        />
        
        <FormInput
          label={t('common.confirmPassword')}
          type="password"
          name="password_confirmation"
          value={form.password_confirmation}
          onChange={handleOnChange}
          errors={errors.password_confirmation}
          required
        />
        
        <div className="my-48">
          <p className="text-gray-500">
            {t('common.personalData')}
            <Link to="#" className="text-main-600 text-decoration-underline tw-capitalize">
              {t('common.privacyPolicy')}
            </Link>
            .
          </p>
        </div>
        <div className="mt-48">
          <button 
            type="submit" 
            className="px-40 btn btn-main py-18"
            disabled={loading}
          >
            {loading ? t('common.registering') : t('common.register')}
          </button>
          <p className="mt-24">
            {t('common.alreadyHaveAccount')}
            <Link to="/login" className="tw-ml-2 text-main-600 text-decoration-underline">
              {t('common.login')}
            </Link>
          </p>
        </div>
      </form>
    </div>
  );
};

export default Register; 